import { IQuestion } from '@bridebook/models/source/models/Suppliers/Questions.types';

export const buildFaqs = (questions: IQuestion[]): { question: string; answer: string }[] =>
  [...questions]
    .sort((a, b) => (a.order || 0) - (b.order || 0))
    .map(({ question, answer }) => ({
      question,
      answer,
    }));
